<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    padding:0px;
    margin:0px;
  }
  html, body{
    height:100%;
  }
  body{
    background:#f0f2f5;
  }
  #app{
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue